import React from 'react';

/**
 * Renders a form row with label + input.
 * All custom components — zero @wordpress/components dependency.
 *
 * @param {string}   label         - Row label text
 * @param {string}   key           - Settings key
 * @param {string}   type          - 'checkBox' | 'select' | 'textArea' | '' (text)
 * @param {Array}    options        - [{label, value}] for select
 * @param {string}   checkboxLabel - Optional label beside checkbox
 * @param {Object}   Settings      - Current settings state
 * @param {Function} updateSetting - (key, value) => void
 * @param {*}        description   - Optional description node
 */
export const renderInputRow = (
  label,
  key,
  type = 'text',
  options = [],
  checkboxLabel = '',
  Settings = {},
  updateSetting = () => {},
  description = '',
  disabled = false,
) => {
  const value = Settings[key];

  return (
    <div className="cf-form-row" key={key}>
      {/* Label column */}
      <label className="cf-form-label" htmlFor={`cf-field-${key}`}>
        {label} {disabled && <span className="pqd-pro-badge"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M3 7l4 4 5-7 5 7 4-4-2 13H5L3 7z"/></svg>PRO</span>}
      </label>

      {/* Field column */}
      <div className="cf-form-field">
        {type === 'select' ? (
          <select
            id={`cf-field-${key}`}
            className="cf-select"
            value={value || ''}
            onChange={(e) => updateSetting(key, e.target.value)}
          >
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>

        ) : type === 'textArea' ? (
          <>
            <div className="cf-field-inline">
              <textarea
                id={`cf-field-${key}`}
                className="cf-textarea"
                value={value || ''}
                onChange={(e) => updateSetting(key, e.target.value)}
                rows={4}
                disabled={disabled}
              />

              {disabled === true && (
                <span style={{fontSize: '13px', fontWeight: 600}}>
                    This Option Is Available In{' '}
                  <a
                    className="cf-pro-link"
                    href="https://www.plugin999.com/plugin/custom-fields-account-registration-for-woocommerce/"
                  >
                    Pro Version
                  </a>
                </span>
              )}
            </div>

            {description && (
              <span className="cf-field-hint">{description}</span>
            )}
          </>
        ) : type === 'checkBox' ? (
          <label className="cf-toggle-wrap">
            <span className="cf-toggle">
              <input
                id={`cf-field-${key}`}
                type="checkbox"
                checked={value === 'yes'}
                onChange={(e) => updateSetting(key, e.target.checked ? 'yes' : 'no')}
              />
              <span
                className="cf-toggle__slider"
                role="button"
                tabIndex={0}
                aria-pressed={value === 'yes'}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); updateSetting(key, value === 'yes' ? 'no' : 'yes'); }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    updateSetting(key, value === 'yes' ? 'no' : 'yes');
                  }
                }}
              />
            </span>
            {checkboxLabel && (
              <span className="cf-toggle-label">{checkboxLabel}</span>
            )}
          </label>

        ) : (
          <>
            <div className="cf-field-inline">
              <input
                id={`cf-field-${key}`}
                type="text"
                className="cf-input"
                value={value || ''}
                onChange={(e) => updateSetting(key, e.target.value)}
                disabled={disabled}
              />

              {disabled === true && (
               <span style={{fontSize: '13px', fontWeight: 600}}>
                  This Option Is Available In{' '}
                  <a
                    className="cf-pro-link"
                    href="https://www.plugin999.com/plugin/custom-fields-account-registration-for-woocommerce/"
                  >
                    Pro Version
                  </a>
                </span>
              )}
            </div>

            {description && (
              <span className="cf-field-hint">{description}</span>
            )}
          </>
        )}
      </div>
    </div>
  );
};
